import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {StripePaymentComponent} from './stripe-payment.component';

@NgModule({
    declarations: [
        StripePaymentComponent
    ],
    imports: [
        BrowserModule
    ],
    exports: [
        StripePaymentComponent
    ],
    providers: [],
    bootstrap: [StripePaymentComponent]
})
export class StripePaymentModule { }



// WEBPACK FOOTER //
// /app/src/app/components/stripe-payment/stripe-payment.module.ts